module.exports = __webpack_public_path__ + "static/media/book13.092765dd.jpg";